<template>
    <div class="d-flex align-items-center justify-content-between mx-1 mt-2 list-wrapper">
        <div
          style="cursor: pointer;"
          @click.prevent="downloadItem"
        >{{ item.name }}</div>
        <div class="text-right">
            <core-icon
              @click.native="deleteItem"
              class="pointer"
              iconName="Delete"
              iconColor="#bdbdbd"
            >
              <icons-close></icons-close>
            </core-icon>
        </div>
    </div>
</template>

<script>
import ReservationLineMedia from '@/services/hatsApi/ReservationLineMedia'
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    async downloadItem () {
      try {
        let downloadMediaResponse = await ReservationLineMedia.downloadMedia(this.item.id)
        if (downloadMediaResponse.data) {
          const file = new Blob(
            [downloadMediaResponse.data],
            { type: downloadMediaResponse.data.type }
          )
          const fileURL = URL.createObjectURL(file)
          window.open(fileURL)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deleteItem () {
      try {
        let deleteMediaResponse = await ReservationLineMedia.deleteMedia(this.item.id)
        if (deleteMediaResponse.data.success) {
          this.$emit('deleted', true)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .list-wrapper {
    border-bottom: 1px solid #e5e5e5;
  }
</style>



// WEBPACK FOOTER //
// src/components/reservation/details/MediaItem.vue